<style>
  .layout.row {
    margin-bottom: 20px!important;
  }
</style>
<template>
  <div id="pageTable">

    <v-alert
            v-model="!activePermission.saveButtonDisabled"
            style="position: fixed; z-index:1000; right:0px; top: 0px; width:100%"
            dissmissible
            :value="true"
            type="warning"
    >
      Данные по доступам не сохранены! Перед закрытием вкладки, сохраните все данные!
    </v-alert>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Роли</h3>
          <v-btn
                  color="pink"
                  dark
                  small
                  fab
                  @click="editOpen()"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
                  color="blue"
                  dark
                  small
                  fab
                  @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>        
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Поиск"
              v-model="search"
              hide-details
              class="hidden-sm-and-down"
              ></v-text-field>     
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>         
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="roleData"
                :rows-per-page-items="[20,35,50,100]"
                class="elevation-1"
                item-key="roleId"
                no-results-text="Нет результатов"
                rows-per-page-text="На странице"
                v-model="complex.selected"
                >
                <template slot="items" slot-scope="props">

                  <td>{{ props.item.roleId }}</td>
                  <td>{{ props.item.roleKey }}</td>
                  <td>
                    <v-chip :class="props.item.roleColor"
                            text-color="white"
                    >
                      <v-avatar>
                        <v-icon>account_circle</v-icon>
                      </v-avatar>
                      {{ props.item.roleTitle }}
                    </v-chip>
                  </td>
                  <td>

                    <v-btn v-if="activePermission.saveButtonDisabled"
                           depressed
                           outline
                           icon
                           fab
                           dark
                           color="blue"
                           small
                           @click="props.expanded = !props.expanded; expandRow(props.item);">
                      <v-icon v-if="!props.expanded">expand_more</v-icon>
                      <v-icon v-if="props.expanded">expand_less</v-icon>
                    </v-btn>

                    <v-btn v-if="activePermission.saveButtonDisabled" depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn v-if="activePermission.saveButtonDisabled" depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>

                  </td>
                </template>

                <template slot="expand" slot-scope="props">
                  <v-card flat  style="background:#f1f0f0;">
                    <v-card-text>
                      <v-layout>
                      <v-container fluid>
                        <div style="font-size: 16px; margin-bottom: 10px;">Объект управления</div>
                        <v-chip label xs3 v-for="obj in objectData"
                                v-bind:data="obj"
                                v-bind:key="obj.objectId"
                               v-bind:class="[
                                    { 'error': props.item.permission.filter(p => {return parseInt(p.object) === obj.objectId && parseInt(p.level) === levelData.filter(l => {return l.levelKey === 'ALL'})[0].levelId }).length !== 0 },
                                    { 'warning': props.item.permission.filter(p => {return parseInt(p.object) === obj.objectId && parseInt(p.level) === levelData.filter(l => {return l.levelKey === 'SUB'})[0].levelId }).length !== 0 },
                                    { 'primary': props.item.permission.filter(p => {return parseInt(p.object) === obj.objectId && parseInt(p.level) === levelData.filter(l => {return l.levelKey === 'MY'})[0].levelId }).length !== 0 },
                                    { 'primary primary-customer': props.item.permission.filter(p => {return parseInt(p.object) === obj.objectId && parseInt(p.level) === levelData.filter(l => {return l.levelKey === 'AS_CUST'})[0].levelId }).length !== 0 },
                                    { 'success': props.item.permission.filter(p => {return parseInt(p.object) === obj.objectId && parseInt(p.level) === levelData.filter(l => {return l.levelKey === 'AS_KAM'})[0].levelId }).length !== 0 },
                                    { 'disabled': props.item.permission.filter(p => {return parseInt(p.object) === obj.objectId && parseInt(p.level) === levelData.filter(l => {return l.levelKey === 'NONE'})[0].levelId }).length !== 0 }
                                  ]"
                                @click="showPermissionLevel(obj.objectId);"
                        >
                          {{ obj.objectTitle }}
                        </v-chip>

                      </v-container>
                      <v-container fluid>
                        <v-card v-if="activePermission.showLevel">
                          <v-card-title primary-title>
                            <div>
                              <h3 class="headline mb-0">Уровень доступа для <span class="pink--text" style="border-bottom:1px dashed">{{ activePermission.title }}</span></h3>
                              <div style="padding:10px">
                                <v-chip xs3 label v-for="lvl in levelData"
                                       v-bind:data="lvl"
                                       v-bind:key="lvl.levelId"
                                       v-bind:class="[
                                          { 'active': props.item.permission.filter(p => {return parseInt(p.level) === lvl.levelId && parseInt(p.object) === activePermission.objId}).length !== 0 },
                                          { 'error': lvl.levelKey === 'ALL' },
                                          { 'warning': lvl.levelKey === 'SUB' },
                                          { 'primary': lvl.levelKey === 'MY' }, 
                                          { 'primary primary-customer': lvl.levelKey === 'AS_CUST' }, 
                                          { 'success': lvl.levelKey === 'AS_KAM' },
                                          { 'disabled': lvl.levelKey === 'NONE' }
                                        ]"
                                       @click="changePermissionLevel(props.item, lvl.levelId)"
                                >
                                  {{ lvl.levelTitle }}
                                </v-chip>
                              </div>
                            </div>
                          </v-card-title>

                          <v-card-actions v-if="!activePermission.saveButtonDisabled">
                            <v-btn
                                    flat
                                    color="pink"
                                    @click="props.expanded = !props.expanded; changePermissionCancel();"
                            >Отмена всех изменений</v-btn>
                            <v-btn
                                    flat
                                    color="blue"
                                    @click="props.expanded = !props.expanded; changePermissionSave();"
                            >Сохранить</v-btn>

                          </v-card-actions>

                        </v-card>

                      </v-container>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </template>

              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID роли</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="ID роли"
                                    v-model="modalData.roleId"
                                    readonly
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Внешний ключ для роли</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <span v-if="readonlyFields">{{modalData.roleKey}}</span>
                            <v-text-field
                                    v-if="!readonlyFields"
                                    label="Внешний ключ для роли"
                                    v-model="modalData.roleKey"
                                    :rules="rules.rolekey"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Наименование роли</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="Наименование роли"
                                    v-model="modalData.roleTitle"
                                    :rules="rules.required"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Цвет</v-subheader>
                          </v-flex>
                          <v-flex v-if="!openColorBox" xs8>
                            <v-chip :class="modalData.roleColor"
                                    text-color="white"
                                    @click="openColorBox = true"
                            >
                              <v-avatar>
                                <v-icon>account_circle</v-icon>
                              </v-avatar>
                              {{modalData.roleTitle}}
                            </v-chip>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!--Выбор цвета-->
                <v-dialog v-model="openColorBox" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span>Выбор цвета</span>
                    </v-card-title>
                    <v-card-text>
                        <v-flex v-for="(color, key) in computedColors" :key="key">
                          <v-card :color="`${key}`"
                                  :class="getColorClass(key)"
                                  :key="key"
                                  tile="tile"
                                  style="cursor:pointer"
                          >
                            <v-card-text @click="changeRoleColor(key)">
                              <v-flex class="caption" >
                                <span>{{ key }}&nbsp;</span>
                              </v-flex>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="primary" flat @click="openColorBox=false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>

              <!-- Удаление -->

              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить роль?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<style>
  .role-object-row {
    padding: 10px;
    border: 1px solid #aaaaaa;
    text-align: center;
    font-size: 16px;
    color: #878686;
    margin-bottom: -1px;
    cursor: pointer;
    background: #f1f0f0;
  }
  .active {
    background: #ffffff;
  }
</style>

<script>
    import colors from 'vuetify/es5/util/colors';
    import Util from '@/util';

    export default {
        components: {
        },
        data () {
            return {
                modalData: {},
                oldModalData: {},
                editedIndex: {},
                valid: true,
                readonlyFields: true,
                openColorBox: false,
                colors,
                rules: {
                    required: [ v => !!v || 'Обязательное поле' ],
                    rolekey: [
                        v => !!v || 'Ключ не может быть пустым',
                        v => v.split(' ').length === 1 || 'Нельзя использовать пробелы',
                        v => this.roleData.filter(el => el.roleKey === v).length === 0 || 'Такой ключ уже существует',
                    ],
                },
                search: '',
                popupRemove: {
                    isOpen: false
                },
                popupEdit: {
                    isOpen: false,
                    isEditing: false,
                },
                complex: {
                    selected: [],
                    headers: [
                        {
                            text: 'ID роли',
                            value: 'roleId'
                        },
                        {
                            text: 'Внешний ключ',
                            value: 'roleKey'
                        },
                        {
                            text: 'Наименование роли',
                            value: 'roleTitle'
                        },
                        {
                            text: 'Действия',
                            value: ''
                        }
                    ],
                },
                activePermission: {
                    showLevel: false,
                    saveButtonDisabled: true,
                    oldPermissionData: {},
                    permissionData: {},
                    editedIndex: '',
                    title: '',
                    objKey: '',
                    objId: '',
                },
            };
        },
        mounted: function () {
            /**
             * Загружаем данные по ролям при первой отрисовке страницы, если roleData не пустой, то не обновляемся
             */
            if (this.roleData.length === 0)
            {
                this.refresh();
            }

            /**
             * Загружаем данные по объектам управления, если objectData не пустой, то не обновляемся
             */
            if (this.$store.getters['object/objectData'].length === 0)
            {
                this.$store._actions['object/getObjectData'][0]();
            }

            /**
             * Загружаем данные по уровням управления, если levelData не пустой, то не обновляемся
             */
            if (this.$store.getters['level/levelData'].length === 0)
            {
                this.$store._actions['level/getLevelData'][0]();
            }

        },

        computed: {

            /**
             * Данные по ролям
             * @returns {default.computed.roleData|(function())|Array|getters.roleData}
             */
            roleData () {
                return this.$store.getters['role/roleData']
            },

            /**
             * Данные по объектам
             * @returns {default.computed.objectData|(function())|Array|getters.objectData}
             */
            objectData () {
                return this.$store.getters['object/objectData']
            },

            /**
             * Данные по уровням
             * @returns {default.computed.levelData|(function())|Array|getters.levelData}
             */
            levelData () {
                return this.$store.getters['level/levelData']
            },

            /**
             * Цвета для выбора в модальном окне
             * @returns (colors)
             */
            computedColors () {
                const colors = {};
                const search = this.search.toLowerCase();

                Object.keys(this.colors).forEach(key => {
                    const kebabKey = Util.kebab(key).toLowerCase();

                    if (kebabKey.indexOf(search) > -1) {
                        colors[kebabKey] = this.colors[key];
                    }
                });
                return colors;
            },
        },

        methods: {

            /**
             * Обновление данных по ролям
             */
            refresh () {
                this.$store._actions['role/getRoleData'][0]();
            },

            /**
             * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
             * @param item
             */
            editOpen (item) {
                // Если редактирование
                if (item !== null && typeof (item) !== 'undefined') {
                    this.modalData = item;
                    this.oldModalData = Object.assign({}, item);
                    this.editedIndex = this.roleData.indexOf(item);
                    this.readonlyFields = true;
                    // Если добавление
                } else {
                    this.modalData = {
                        roleId: -1,
                        roleKey: '',
                        roleTitle: '',
                        roleColor: '',
                    };
                    this.oldModalData = {};
                    this.editedIndex = -1;
                    this.readonlyFields = false;
                }
                this.popupEdit.isOpen = true;
            },

            /**
             * Отмена редактирования
             */
            editCancel () {
                if (this.editedIndex != -1) {
                    Object.assign(this.roleData[this.editedIndex], this.oldModalData);
                }
                this.popupEdit.isOpen = false;
            },

            /**
             * Сохранение отредактированного элемента
             */
            submit () {
                if (this.$refs.form.validate()) {
                    this.$store._actions['role/saveRoleData'][0]({index: this.editedIndex, data: this.modalData}).then(() => {
                        this.popupEdit.isOpen = false;
                    })
                }
            },

            /**
             * Открытие модального окна с подтверждением удаления
             * @param data
             */
            removeItemConfirm (data) {
                this.popupRemove.isOpen = true;
                this.modalData = data;
            },

            /**
             * Удаление элемента
             * @param item
             */
            actionRemove (item) {
                this.$store._actions['role/removeRoleData'][0]({item: item});
                this.popupRemove.isOpen = false;
            },

            /**
             * Изменение цвета по клику
             * @param color
             */
            changeRoleColor (color) {
                this.modalData.roleColor = color;
                this.openColorBox = false;
            },

            /**
             * Вывод последнего элемента
             * @param str
             * @returns {*}
             */
            endStr (str) {
                return str[str.length - 1];
            },

            /**
             * Конвертирование в строки в класс
             * @param str
             * @returns {*}
             */
            convertToClass (str) {
                const end = this.endStr(str);
                const sub = str.substr(0, str.length - 1);

                if (isNaN(parseInt(end, 10))) return str;

                return `${sub}-${end}`;
            },

            /**
             * Получение цвета по ключу
             * @param key
             * @returns {string}
             */
            getColorClass (key) {
                if (['white', 'transparent'].includes(key) ||
                    key.indexOf('light') > -1 ||
                    key.indexOf('accent') > -1
                ) return 'black--text';

                return 'white--text';
            },

            /**
             * Раскрытие вкладки с объектами и уровнями доступа.
             * При открытии вкладки сохраняется старое состояние роли, на случай отмены изменений.
             * Также создаются объекты с ролью для ее редактирования и последующего сохранения, и индекс этой роли.
             * @param item
             */
            expandRow(item) {



                this.activePermission.showLevel = false;
                this.activePermission.objId = '';
                this.activePermission.title = '';
                this.activePermission.saveButtonDisabled = true;
                this.activePermission.editedIndex = this.roleData.indexOf(item);
                this.activePermission.permissionData = item;
                this.activePermission.oldPermissionData = JSON.parse(JSON.stringify(item));
            },

            /**
             * Открытие диалогового окна с уровнями доступа к объекту управления
             * @param objId
             */
            showPermissionLevel(objId) {
                this.activePermission.showLevel = true;
                this.activePermission.objId = objId;
                this.activePermission.title = this.objectData.filter(x => x.objectId === objId)[0].objectTitle;
            },

            /**
             * Изменение уровня доступа к объекту управления.
             * @param item
             * @param levelId
             */
            changePermissionLevel(item, levelId){
                // Проверка на нахождение выбранного объекта управления в модели роли.
                // Если такой объект есть - удаляем. Так как несколько уровней доступа на один объект быть не может
                item.permission.forEach(p => {
                    if (parseInt(p.object) === parseInt(this.activePermission.objId)) {
                        item.permission = item.permission.filter(iItem => iItem !== item.permission[item.permission.indexOf(p)]);
                    }
                });
                // Добавляем связку объект:уровень в модель роли
                item.permission.push({
                    object: this.activePermission.objId,
                    level: levelId
                });
                this.activePermission.saveButtonDisabled = false;
            },

            /**
             * Отмена всех измений при редактировании уровней доступа к объектам управления
             */
            changePermissionCancel() {
                Object.assign(this.roleData[this.activePermission.editedIndex], this.activePermission.oldPermissionData);
                this.activePermission.saveButtonDisabled = true;
                this.activePermission.oldPermissionData = {};
                this.activePermission.permissionData = {};
                this.activePermission.editedIndex = '';
            },

            /**
             * Сохранение измений по уровням доступа к объектам управления
             */
            changePermissionSave() {
                this.$store._actions['role/saveRoleData'][0]({index: this.activePermission.editedIndex, data: this.activePermission.permissionData}).then(() => {
                    this.activePermission.saveButtonDisabled = true;
                    this.activePermission.oldPermissionData = {};
                    this.activePermission.permissionData = {};
                    this.activePermission.editedIndex = '';
                })
            }
        }
    };
</script>

<style>
  .v-chip__content{
    cursor: pointer!important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/ui/Roles.vue